import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetPaymentAdProductsUseCase extends UseCase {
  constructor({repository, getCurrentUserService, getPaymentAdProductsError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._getPaymentAdProductsError = getPaymentAdProductsError
  }

  _throwGetPaymentAdProductsError(message) {
    throw this._getPaymentAdProductsError(`[HTTPPaymentAdProductsRepository#get] ${message}`)
  }

  _getCurrentUser = async () => this._getCurrentUserService.execute()

  _getUserId = async () => {
    const currentUser = await this._getCurrentUser()
    return currentUser ? currentUser.getId() : this._throwGetPaymentAdProductsError('Unknow user ID')
  }

  /**
   * @return {Promise<Object, Error>}
   */
  execute = async ({adId}) => {
    const userId = await this._getUserId()
    const paymentAdProduct = await this._repository.getPaymentAdProduct({
      userId,
      adId
    })
    return {product: paymentAdProduct.toJSON()}
  }
}
